//**************************************************************************************************
//  セッションサービス
//**************************************************************************************************
//==================================================================================================
//  import
//==================================================================================================
import { Injectable, NgZone } from '@angular/core';

import { getAuth, onAuthStateChanged, signOut, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendEmailVerification, sendPasswordResetEmail, setPersistence, browserLocalPersistence, getIdToken, Auth, User, getMultiFactorResolver, MultiFactorError } from 'firebase/auth';

import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';

import { Firestore, collection, getDoc, getDocs, doc, query, where , orderBy} from '@angular/fire/firestore';

import { AppConst } from '../../app-const';

import { Session } from '../../class/session';

import { FireSysAdmin } from '../../class/fire/sys_admin';
import { FireOpAdmin } from '../../class/fire/op_admin';
import { FireOpUser } from '../../class/fire/op_user'
import { FireGroup } from '../../class/fire/group'
import { FireOpr } from '../../class/fire/opr'


import { TranslateService } from '@ngx-translate/core';

import { LoginHttpService } from '../../function/login/login-service/login-http.service';

import { LoadingService } from './loading.service';

import { FirestoreUtil } from '../utility/firestore-util';
//==================================================================================================
@Injectable({
  providedIn: 'root',
})
//==================================================================================================
//
//==================================================================================================
export class SessionService {
  //================================================================================================
  //  変数定義
  //============================|===================================================================
  session                       = new Session();
  sessionSubject                = new Subject<Session>();
  sessionState                  = this.sessionSubject.asObservable();

  auth                          : Auth | null = null;
  user                          : User | null = null;
  unsubscribe                   : any;
  authObservable!               : Observable<Session>;
  //================================================================================================
  //  コンストラクタ
  //============================|===================================================================
  constructor(
    private router              : Router,
    private ngZone              : NgZone,
    private firestore           : Firestore,
    private loginHttpService    : LoginHttpService,
    private loadingService      : LoadingService,
    private translate           : TranslateService) {
      this.auth                 = getAuth();
      // this.subscribeAuth();
      setPersistence(this.auth, browserLocalPersistence);
    }
  //================================================================================================
  //  認証済みチェック
  //================================================================================================
  // private subscribeAuth(): void {
  //   onAuthStateChanged(this.auth!, async user => {
  //   });
  // }
  //================================================================================================
  //  ログイン：メール／パスワード  ２要素認証なし
  //================================================================================================
  loginEmail(email: string, password: string): void {
    signInWithEmailAndPassword(this.auth!, email!, password!)
      .then(async (result) => {
        //------------------------------------------------------------------------------------------
        this.user           = result.user;
        const user          = result.user;
        //------------------------------------------------------------------------------------------
        if (result.user.emailVerified !== true) {
          return Promise.reject(this.translate.instant('TS-session.メールアドレスが確認できていません。'));
        }
        //------------------------------------------------------------------------------------------
        const sysAdmin  = FirestoreUtil.createDoc<FireSysAdmin>(await getDoc(doc(this.firestore, AppConst.TABLE_SYS_ADMIN, user!.email!)))
        const opAdmin   = FirestoreUtil.createDoc<FireOpAdmin>(await getDoc(doc(this.firestore, AppConst.TABLE_OP_ADMIN, user!.email!)))
        const opUser    = FirestoreUtil.createDoc<FireOpUser>(await getDoc(doc(this.firestore, AppConst.TABLE_OP_USER, user!.email!)))
        //------------------------------------------------------------------------------------------
        if (!!sysAdmin && !opAdmin && !opUser) {
          this.session.isLogin      = true;
          this.session.uid          = user!.uid;
          this.session.sysAdmin     = sysAdmin;
          this.session.opAdmin      = null;
          this.session.opUser       = null;
          this.session.group        = null;
          this.session.opr          = null;
          this.log_login(sysAdmin.email!, null);
          this.sessionSubject.next(this.session);
          this.ngZone.run(() => {
            this.router.navigate(['/group']);
          });
        } else {
          if (!sysAdmin && !!opAdmin && !opUser) {
            const group               = FirestoreUtil.createDoc<FireGroup>(await getDoc(doc(this.firestore, AppConst.TABLE_GROUP, opAdmin.group_code!)))
            this.session.isLogin      = true;
            this.session.uid          = user!.uid;
            this.session.sysAdmin     = null;
            this.session.opAdmin      = opAdmin;
            this.session.opUser       = null;
            this.session.group        = group;
            this.session.opr          = null;
            this.log_login(opAdmin.email!, opAdmin.group_code!);
            this.sessionSubject.next(this.session);
            this.ngZone.run(() => {
              this.router.navigate(['/opr']);
            });
          } else {
            if (!sysAdmin && !opAdmin && !!opUser) {
              const group               = FirestoreUtil.createDoc<FireGroup>(await getDoc(doc(this.firestore, AppConst.TABLE_GROUP, opUser.group_code!)))
              this.session.isLogin      = true;
              this.session.uid          = user!.uid;
              this.session.sysAdmin     = null;
              this.session.opAdmin      = null;
              this.session.opUser       = opUser;
              this.session.group        = group;
              this.session.opr          = null;
              this.log_login(opUser.email!, opUser.group_code!);
              this.sessionSubject.next(this.session);
              this.ngZone.run(() => {
                this.router.navigate(['/opr']);
              });
            }
          }
        }
        return Promise.resolve('success');
      })
      .catch((error) => {
        alert(this.translate.instant('TS-session.ログインに失敗しました。')+ '\n' + error);
      });
  }
  //================================================================================================
  //  ログイン：メール／パスワード　２要素認証あり  ステップ１
  //================================================================================================
  loginEmail2FA_Step1(admin_id: string, password: string): Promise<any> {
    return signInWithEmailAndPassword(this.auth!, admin_id!, password!)
    .then(async (result) => {
      //------------------------------------------------------------------------------------------
      this.user           = result.user;
      const user          = result.user;
      //------------------------------------------------------------------------------------------
      if (result.user.emailVerified !== true) {
        return Promise.reject(this.translate.instant('TS-session.メールアドレスが確認できていません。'));
      }
      //------------------------------------------------------------------------------------------
      const sysAdmin  = FirestoreUtil.createDoc<FireSysAdmin>(await getDoc(doc(this.firestore, AppConst.TABLE_SYS_ADMIN, user!.email!)))
      const opAdmin   = FirestoreUtil.createDoc<FireOpAdmin>(await getDoc(doc(this.firestore, AppConst.TABLE_OP_ADMIN, user!.email!)))
      const opUser    = FirestoreUtil.createDoc<FireOpUser>(await getDoc(doc(this.firestore, AppConst.TABLE_OP_USER, user!.email!)))
      //------------------------------------------------------------------------------------------
      if (!!sysAdmin && !opAdmin && !opUser) {
        this.ngZone.run(() => {
          this.session.isLogin      = true;
          this.session.is2FA        = false;
          this.session.uid          = user!.uid;
          this.session.sysAdmin     = sysAdmin;
          this.session.opAdmin      = null;
          this.session.opUser       = null;
          this.session.group        = null;
          this.session.opr          = null;
          this.router.navigate(['/twofactor']);
        });
      } else {
        if (!sysAdmin && !!opAdmin && !opUser) {
          this.ngZone.run(() => {
            this.session.isLogin      = true;
            this.session.is2FA        = false;
            this.session.uid          = user!.uid;
            this.session.sysAdmin     = null;
            this.session.opAdmin      = opAdmin;
            this.session.opUser       = null;
            this.session.group        = null;
            this.session.opr          = null;
            this.router.navigate(['/twofactor']);
          });
        } else {
          if (!sysAdmin && !opAdmin && !!opUser) {
            this.ngZone.run(() => {
              this.session.isLogin      = true;
              this.session.is2FA        = false;
              this.session.uid          = user!.uid;
              this.session.sysAdmin     = null;
              this.session.opAdmin      = null;
              this.session.opUser       = opUser;
              this.session.group        = null;
              this.session.opr          = null;
              this.router.navigate(['/twofactor']);
            });
          } else {
            signOut(this.auth!);
          }
        }
      }
      return Promise.resolve('success');
    }).then(() => {return null;})
    .catch((error) => {
      if (error.code == 'auth/multi-factor-auth-required') {
        const resolver = getMultiFactorResolver(this.auth!, error as MultiFactorError)
        return resolver;
      } else {
        alert(this.translate.instant('TS-session.ログインに失敗しました。')+ '\n' + error);
        return null;
      }
    });
  }
  //================================================================================================
  //  ログイン：メール／パスワード　２要素認証あり  ステップ２
  //================================================================================================
  loginEmail2FA_Step2(resolver: any, multiFactorAssertion: any) {
    resolver.resolveSignIn(multiFactorAssertion)
    .then(async (auth: any) => {
      //------------------------------------------------------------------------------------------
      this.user           = auth.user;
      const user          = auth.user;
      //------------------------------------------------------------------------------------------
      const sysAdmin  = FirestoreUtil.createDoc<FireSysAdmin>(await getDoc(doc(this.firestore, AppConst.TABLE_SYS_ADMIN, user!.email!)))
      const opAdmin   = FirestoreUtil.createDoc<FireOpAdmin>(await getDoc(doc(this.firestore, AppConst.TABLE_OP_ADMIN, user!.email!)))
      const opUser    = FirestoreUtil.createDoc<FireOpUser>(await getDoc(doc(this.firestore, AppConst.TABLE_OP_USER, user!.email!)))
      //------------------------------------------------------------------------------------------
      if (!!sysAdmin && !opAdmin && !opUser) {
        this.session.isLogin      = true;
        this.session.is2FA        = true;
        this.session.uid          = user!.uid;
        this.session.sysAdmin     = sysAdmin;
        this.session.opAdmin      = null;
        this.session.opUser       = null;
        this.session.group        = null;
        this.session.opr          = null;
        this.log_login(sysAdmin.email!, null);
        this.sessionSubject.next(this.session);
        this.ngZone.run(() => {
          this.router.navigate(['/group']);
        });
      } else {
        if (!sysAdmin && !!opAdmin && !opUser) {
          const group        = FirestoreUtil.createDoc<FireGroup>(await getDoc(doc(this.firestore, AppConst.TABLE_GROUP, opAdmin.group_code!)))
          this.session.isLogin      = true;
          this.session.is2FA        = true;
          this.session.uid          = user!.uid;
          this.session.sysAdmin     = null;
          this.session.opAdmin      = opAdmin;
          this.session.opUser       = null;
          this.session.group        = group;
          this.session.opr          = null;
          this.log_login(opAdmin.email!, opAdmin.group_code!);
          this.sessionSubject.next(this.session);
          this.ngZone.run(() => {
            this.router.navigate(['/opr']);
          });
        } else {
          if (!sysAdmin && !opAdmin && !!opUser) {
            const group        = FirestoreUtil.createDoc<FireGroup>(await getDoc(doc(this.firestore, AppConst.TABLE_GROUP, opUser.group_code!)))
            this.session.isLogin      = true;
            this.session.is2FA        = true;
            this.session.uid          = user!.uid;
            this.session.sysAdmin     = null;
            this.session.opAdmin      = null;
            this.session.opUser       = opUser;
            this.session.group        = group;
            this.session.opr          = null;
            this.log_login(opUser.email!, opUser.group_code!);
            this.sessionSubject.next(this.session);
            this.ngZone.run(() => {
              this.router.navigate(['/opr']);
            });
          } else {
            signOut(this.auth!);
          }
        }
      }
    })
    .catch((error: any) => {
      alert(this.translate.instant('TS-session.ログインに失敗しました。')+ '\n' + error);
      return null;
    });
  }
  //================================================================================================
  //  ログイン：メール／パスワード　２要素認証あり  ステップ２
  //================================================================================================
  async loginEmail2FA_Step3(auth: any) {
    //------------------------------------------------------------------------------------------
    this.user       = auth;
    const user      = auth;
    //------------------------------------------------------------------------------------------
    const sysAdmin  = FirestoreUtil.createDoc<FireSysAdmin>(await getDoc(doc(this.firestore, AppConst.TABLE_SYS_ADMIN, user.email!)))
    const opAdmin   = FirestoreUtil.createDoc<FireOpAdmin>(await getDoc(doc(this.firestore, AppConst.TABLE_OP_ADMIN, user.email!)))
    const opUser    = FirestoreUtil.createDoc<FireOpUser>(await getDoc(doc(this.firestore, AppConst.TABLE_OP_USER, user.email!)))
    //------------------------------------------------------------------------------------------
    if (!!sysAdmin && !opAdmin && !opUser) {
      this.session.isLogin      = true;
      this.session.is2FA        = true;
      this.session.uid          = user!.uid;
      this.session.sysAdmin     = sysAdmin;
      this.session.opAdmin      = null;
      this.session.opUser       = null;
      this.session.group        = null;
      this.session.opr          = null;
      this.log_login(sysAdmin.email!, null);
      this.sessionSubject.next(this.session);
      this.ngZone.run(() => {
        this.router.navigate(['/group']);
      });
    } else {
      if (!sysAdmin && !!opAdmin && !opUser) {
        const group        = FirestoreUtil.createDoc<FireGroup>(await getDoc(doc(this.firestore, AppConst.TABLE_GROUP, opAdmin.group_code!)))
        this.session.isLogin      = true;
        this.session.is2FA        = true;
        this.session.uid          = user!.uid;
        this.session.sysAdmin     = null;
        this.session.opAdmin      = opAdmin;
        this.session.opUser       = null;
        this.session.group        = group;
        this.session.opr          = null;
        this.log_login(opAdmin.email!, opAdmin.group_code!);
        this.sessionSubject.next(this.session);
        this.ngZone.run(() => {
          this.router.navigate(['/opr']);
        });
      } else {
        if (!sysAdmin && !opAdmin && !!opUser) {
          const group        = FirestoreUtil.createDoc<FireGroup>(await getDoc(doc(this.firestore, AppConst.TABLE_GROUP, opUser.group_code!)))
          this.session.isLogin      = true;
          this.session.is2FA        = true;
          this.session.uid          = user!.uid;
          this.session.sysAdmin     = null;
          this.session.opAdmin      = null;
          this.session.opUser       = opUser;
          this.session.group        = group;
          this.session.opr          = null;
          this.log_login(opUser.email!, opUser.group_code!);
          this.sessionSubject.next(this.session);
          this.ngZone.run(() => {
            this.router.navigate(['/opr']);
          });
        } else {
          signOut(this.auth!);
        }
      }
    }
  }
  //================================================================================================
  //  ログアウト
  //================================================================================================
  logout(): void {
    signOut(this.auth!)
    .then(() => {
      if (!!this.session.sysAdmin) {
        this.log_logout(this.session.sysAdmin.email!, null);
      } else {
        if (!!this.session.opAdmin) {
          this.log_logout(this.session.opAdmin.email!, this.session.opAdmin.group_code!);
        } else {
          if (!!this.session.opUser) {
            this.log_logout(this.session.opUser.email!, this.session.opUser.group_code!);
          }
        }
      }
      this.sessionSubject.next(this.session.reset());
      return this.router.navigate(['/login']);
    })
    .catch( error => {
      alert(this.translate.instant('TS-session.ログアウトに失敗しました。') + '\n' + error);
    })
  }
  //================================================================================================
  //  パスワードの再設定
  //================================================================================================
  pw_reset(admin_id: string): void {
    // this.log_pw_reset(admin_id);
    sendPasswordResetEmail(this.auth!, admin_id)
      .then((result) => {
        alert(this.translate.instant('TS-session.パスワードの再設定メールを送信しました。'))
		  })
		  .catch((error) => {
        alert(this.translate.instant('TS-session.パスワードの再設定に失敗しました。') + '\n' + error)
		  });
  }
  //================================================================================================
  //  サインアップ
  //================================================================================================
  signup(admin_id: string, password: string): void {
    // this.log_signup(admin_id);
    createUserWithEmailAndPassword(this.auth!, admin_id, password)
      .then((result) => {
        sendEmailVerification(result.user);
        alert(this.translate.instant('TS-session.メールアドレス確認メールを送信しました。'))
		  })
		  .catch((error) => {
        alert(this.translate.instant('TS-session.アカウントの作成に失敗しました。') + '\n' + error)
		  });
  }
  //================================================================================================
  //  ログ出力  ログイン
  //================================================================================================
  log_login(email: string, group_code?: string | null): void {
    const loadingServiceRef = this.loadingService.show();
    this.loginHttpService.login(email).subscribe(result => {
      loadingServiceRef.close();
    });
  }
  //================================================================================================
  //  ログ出力  ログアウト
  //================================================================================================
  log_logout(email: string, group_code?: string | null): void {
    const loadingServiceRef = this.loadingService.show();
    this.loginHttpService.logout(email).subscribe(result => {
      loadingServiceRef.close();
    });
  }
  //================================================================================================
  //  ログ出力  パスワードの再設定
  //================================================================================================
  log_pw_reset(email: string): void {
    const loadingServiceRef = this.loadingService.show();
    this.loginHttpService.pw_reset(email).subscribe(result => {
      loadingServiceRef.close();
    });
  }
  //================================================================================================
  //  ログ出力  サインアップ
  //================================================================================================
  log_signup(email: string): void {
    const loadingServiceRef = this.loadingService.show();
    this.loginHttpService.signup(email).subscribe(result => {
      loadingServiceRef.close();
    });
  }
  //================================================================================================
  //  ログイン状況確認(State)
  //================================================================================================
  checkLoginState(): Observable<Session> {
    return new Observable<Session>(observer => {
      observer.next(this.session);
    });
  }
  //================================================================================================
  //  グループ設定
  //================================================================================================
  setGroup(group: FireGroup | null): void {
    this.session.group = group;
    this.sessionSubject.next(this.session);
  }
  //================================================================================================
  //  OPレジストリ設定
  //================================================================================================
  setOpr(opr: FireOpr | null): void {
    this.session.opr = opr;
    this.sessionSubject.next(this.session);
  }
  //================================================================================================
  //  トークン取得
  //================================================================================================
  async getToken(): Promise<string> {
    let _token = '';
    await getIdToken(this.user!).then(token => {
      _token = token;
    });
    return _token;
  }
}
